import { useCallback, useEffect, useRef } from 'react';

import FormDivider from '@form/FormDivider';
import { Card } from '@ui';
import axios from 'axios';
import { MessageTemplate } from 'components/MessageManagement/types';
import { debounce } from 'lodash';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface Props {
    template?: MessageTemplate;
    withoutWrapper?: true;
    /** @deprecated */
    css?: any;
}

export const TemplatePreview = ({ template, withoutWrapper, css }: Props) => {
    const { t } = useTranslation('message-management');
    const { watch } = useFormContext() || {};
    const iFrame = useRef<HTMLIFrameElement>(null);
    const data = watch?.();

    const updateIFrame = useCallback(
        debounce((data) => {
            axios
                .post(process.env.NEXT_PUBLIC_API_HOST + 'message-management/template/preview', data)
                .then((response) => {
                    const doc = iFrame.current?.contentDocument;
                    if (doc) {
                        doc.open();
                        doc.write(response.data);
                        doc.close();
                    }
                });
        }, 1000),
        []
    );

    const wrapInCard = (component: React.JSX.Element, withoutWrapper: boolean = false) => {
        if (withoutWrapper) return component;
        return (
            <Card className="tw-relative tw-m-0 tw-box-border tw-flex tw-h-auto tw-w-full tw-flex-col tw-overflow-hidden tw-rounded-lg tw-p-0">
                <h5 className="tw-font-size-2xl tw-z-10 tw-p-4 tw-text-accents-9">{t('template.preview.title')}</h5>
                <FormDivider />
                <div>{component}</div>
            </Card>
        );
    };

    useEffect(() => {
        if (!template && data) updateIFrame(data);
    }, [data, template]);

    return wrapInCard(
        <div>
            <iframe
                className={`tw-pointer-events-none tw-absolute tw-inset-0 tw-h-full tw-w-full tw-border-none tw-bg-[url('/images/sportision_logo.svg')] tw-bg-[length:80px] tw-bg-center tw-bg-no-repeat`}
                ref={iFrame}
                src={template ? `${process.env.NEXT_PUBLIC_API_HOST}message-management/template/${template.id}` : null}
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
        </div>,
        withoutWrapper
    );
};
